import {Injectable} from '@angular/core';

@Injectable()
export class LocalStorageService {

  storageId = 'atwork';
  defaultExpiration = 60 * 60 * 1000;   // 1 hour

  // returns JSON parsed data from local storage
  public get(key: string) {
    if (!key) {
      console.warn('LocalStorage:get: key cannot be empty');
      return;
    }

    const storedKey = this.storageId + ' - ' + key;
    let value = localStorage.getItem(storedKey);
    if (value) {
      value = JSON.parse(value).data;
    }
    return value;
  }

  // add new key/value pair data with expiration date
  public add(key: string, value: any, expire?: number) {
    const keyToStore = this.storageId + ' - ' + key;
    let expireToStore = this.defaultExpiration;

    if (expire) {
      expireToStore = expire;
    } else {
      expireToStore += new Date().getTime();
    }
    const valueToStore = JSON.stringify({data: value, expire: expireToStore},
      (_key, value) => (value instanceof Set ? [...value] : value));

    localStorage.setItem(keyToStore, valueToStore);
  }

  // if expired, force delete the data, otherwise delete if the data's expire date is reached
  public delete(key: string, forceDelete?: boolean) {
    if (!key) {
      console.warn('LocalStorage:delete: key cannot be empty');
      return;
    }
    const storedKey = this.storageId + ' - ' + key;

    if (!forceDelete) {
      const value = localStorage.getItem(storedKey);
      if (value) {
        const expire = JSON.parse(value).expire;
        if (expire < new Date().getTime()) {
          localStorage.removeItem(storedKey);
        }
      } else {
        // console.warn(`LocalStorage:delete: could not find data with key = ${key}`);
      }
    } else {
      localStorage.removeItem(storedKey);
    }
  }
}
